import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { StudentContactAttributes } from 'src/lib/services/api/students/contacts/student-contact-options.model';
import { isArray, isDate } from 'src/lib/utilities/compare';
import { isAddress } from 'src/lib/utilities/gradally';
import { IfEmptyPipe } from '../../../pipes/if-empty.pipe';
import { PhoneNumberPipe } from '../../../pipes/phone-number.pipe';
import { AddressDisplayComponent } from '../user-address/address-display.component';

@Component({
	selector: 'ae-update-field-display',
	templateUrl: './update-field-display.component.html',
	styleUrls: ['./update-field-display.component.scss'],
	imports: [
		AddressDisplayComponent,
		DatePipe,
		IfEmptyPipe,
		NgTemplateOutlet,
		PhoneNumberPipe,
	],
})
export class UpdateFieldDisplayComponent {
	@Input({
		required: true,
	})
	public item: unknown;
	@Input({
		required: true,
	})
	public type: 'current_value' | 'proposed_value';
	protected isDate = isDate;
	protected isArray = isArray;
	protected isAddress = isAddress;

	public buildAttributeMessage = (
		attributes: StudentContactAttributes[] = [],
	) => {
		if (
			attributes.find((attr) => {
				return attr === 'guardian';
			}) &&
			attributes.find((attr) => {
				return attr === 'primary';
			})
		) {
			return 'Primary Parent/Guardian';
		}
		if (
			attributes.find((attr) => {
				return attr === 'guardian';
			})
		) {
			return 'Parent/Guardian';
		}
		return '';
	};
}
